<div class="ap-wrap">
	<div class="imgmap-frontend-image">
		<div class="home-imagemap-head-bg"></div>
    <div style="display: block; position: relative;">
      <img
        [src]="project.map_plan.url"
        usemap="#ap-map"
        id="ap-img"
        class="ap-img"
        loading="lazy"
      >
    </div>
		<map name="ap-map">
      <area
				*ngFor="let buildingFloor of buildingFloors, trackBy: listTrackingService.disableUpdate"
        data-type="link"
        [href]="(basePath == '/' ? '' : basePath) + '/bloc/' + project.id + '/' + buildingFloor.id"
        [attr.data-tooltip]="buildingFloor.floor_value"
        data-fill-color="E4BD62"
        data-fill-opacity="0.5"
        data-stroke-color="fefefe"
        data-stroke-opacity="0.8"
        data-stroke-width="2"
        [attr.data-mapkey]="'area-' + buildingFloor.id"
        shape="poly"
        [attr.coords]="buildingFloor.area.join(',')"
      >
		</map>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-building-base.component.html